import React, { useEffect, useState } from 'react';
import { useMarks } from '../../../context/CyamContext';


const calculateAverage = (scores) => {
    const sum = scores.reduce((total, score) => total + score.score, 0);
    return sum / scores.length || 0; // Avoid division by zero
};

const DataTable = ({ suid }) => {

    const { marks } = useMarks();

    let dataArray = [];
    if(marks.length > 0){
        dataArray = marks.filter(student => student.student_uid === suid ).filter(exam =>exam.te ==='Internal-I');
    }

    const [totalMark, setTotalMark] = useState(null);

     useEffect(()=>{
        if(dataArray.length === 2){
            setTotalMark(50);
        }else if(dataArray.length === 3){
            setTotalMark(75);
        }else if(dataArray.length === 4){
            setTotalMark(100);
        }else if(dataArray.length === 5){
            setTotalMark(125);
        }else if(dataArray.length === 6){
            setTotalMark(150);
        }else if(dataArray.length === 7){
            setTotalMark(175);
        }else if(dataArray.length === 8){
            setTotalMark(200);
        }else{
            setTotalMark(225);
        }
    },[dataArray]);

    let slno =1;
    // Your conversion logic
    const convertedArray = dataArray.reduce((result, entry) => {
        // Find existing entry based on student_uid, ac_year, and te
        const existingEntry = result.find(item => 
            item.student_uid === entry.student_uid &&
            item.student === entry.student &&
            item.section === entry.section &&
            item.ac_year === entry.ac_year &&
            item.te === entry.te
        );
    
        // If an existing entry is found, add the score details to its scores array
        if (existingEntry) {
            existingEntry.scores.push({
                subject_name: entry.subject_name,
                subject_code: entry.subject_code,
                score: entry.score
            });
        } else {
            // If no existing entry is found, create a new entry with scores array
            const newEntry = {
                // student_name: entry.student_name.split(' ')[0], // Extract first name
                student_name: entry.student_name,
                student_uid: entry.student_uid,
                student: entry.student,
                section: entry.section,
                ac_year: entry.ac_year,
                te: entry.te,
                scores: [
                    {
                        subject_name: entry.subject_name,
                        subject_code: entry.subject_code,
                        score: entry.score
                    }
                ]
            };
            result.push(newEntry);
        }
    
        return result;
    }, []);

    if (convertedArray.length === 0) {
        return <p>No data available.</p>;
    }

    //Sum of marks
    const sumOfScores = convertedArray.map(entry =>
        entry.scores.reduce((sum, score) => sum + score.score, 0)
    );

    // Percentage of marks
    const percent = ( sumOfScores * 100 )/ totalMark;
    const formattedPercent = parseFloat(percent.toFixed(2));

    return (
        <>
            <table className='table table-bordered'>
                <thead>
                    <tr className='table-dark'>
                        <th className='text-light'>Name</th>
                        <th className='text-light'>UID</th>
                        <th className='text-light'>Academic Year</th>
                        <th className='text-light'>Assessment</th>
                    </tr>
                </thead>
                <tbody>
                    {convertedArray.map((entry, index) => (
                        <tr key={index}>
                            <td className='text-dark'>{entry.student}</td>
                            <td className='text-dark'>{entry.student_uid}</td>
                            <td className='text-dark'>{entry.ac_year}</td>
                            <td className='text-dark'>{entry.te}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <table className='table table-bordered border border-dark'>
                <thead>
                    <tr className='table-dark'>
                        <th className='text-light'>Sl.No.</th>
                        <th className='text-light'>FM</th>
                        
                        <th className='text-light'>PM</th>
                        <th className='text-light'>Subject</th>
                        <th className='text-light'>Secured Marks</th>
                    </tr>
                </thead>
                <tbody>
                    {convertedArray.map((entry, index) => (
                        <tr key={index}>
                           <td className='text-dark'>{entry.scores.map((score, scoreIndex) => (
                                    <div key={scoreIndex}>
                                        {slno ++}
                                    </div>
                                ))}
                            </td>
                            <td className='text-dark'>{entry.scores.map((score, scoreIndex) => (
                                    <div key={scoreIndex}>
                                        100
                                    </div>
                                ))}
                            </td>
                            <td className='text-dark'>{entry.scores.map((score, scoreIndex) => (
                                    <div key={scoreIndex}>
                                        33
                                    </div>
                                ))}
                            </td>
                            <td className='text-dark'>{entry.scores.map((score, scoreIndex) => (
                                    <div key={scoreIndex}>
                                        {score.subject_name}
                                    </div>
                                ))}
                            </td>
                            <td className='text-dark'>
                                {entry.scores.map((score, scoreIndex) => (
                                    <div key={scoreIndex}>
                                        {score.score}
                                    </div>
                                ))}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <table className='table table-bordered'>
                <thead>
                    <tr className='table-dark'>
                        <th className='text-light'>Total Marks Secured</th>
                        <th className='text-light'>Average</th>
                        <th className='text-light'>Percentage (%)</th>
                    </tr>
                </thead>
                <tbody>
                    {convertedArray.map((entry, index) => (
                        <tr key={index}>
                            <td className='text-dark'>
                                {sumOfScores}
                            </td>                            
                            <td className='text-dark'>
                                {`${calculateAverage(entry.scores).toFixed(2)}`}
                            </td>
                            <td className='text-dark'>
                                {formattedPercent}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};

export default DataTable;
